<template>
    <div class="registros">
        <div class="container">
            <div class="row">
                <h1>Listado de Registros</h1>

                <table class="table table-bordered">
                    <thead class="thead-inverse">
                        <tr>
                            <th>Nombre</th>
                            <th>Telefono</th>
                            <th>Origen</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="registro in registros" scope="row">
                            <td>{{ registro.nombre }} {{ registro.apellido }}</td>
                            <td>{{ registro.telefono }}</td>
                            <td>{{ registro.origen }}</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</template>

<script>

import fireApp from '../services/fireConfig.js'
import { getAllRegistros } from '../services/website/website.service.js'

export default {
    name: 'registros',

    data () {
        return {
            registros: null
        }
    },

    created () {
        let cmp = this;

        getAllRegistros(function(p) {
            cmp.registros = p;
        });
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Registros.vue?245b9231